/* =====================================================
   PRODUCT PAGE REDESIGN - LP SEABRA
   JavaScript Interactivity
   ===================================================== */

(function() {
  'use strict';

  // Wait for DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initViewerCount();
    initStickyBar();
    initQuantityControls();
    initGallery();
    initLightbox();
    initTabs();
    initFAQ();
    initSmoothScroll();
    initAddToCartSync();
  }

  /* =====================================================
     1. VIEWER COUNT (Realistic simulation)
     ===================================================== */
  function initViewerCount() {
    const viewersEl = document.querySelector('.viewers-count');
    if (!viewersEl) return;

    // Start with random number between 12-35
    let count = Math.floor(Math.random() * 24) + 12;
    viewersEl.textContent = count;

    // Update every 20-40 seconds
    setInterval(() => {
      const change = Math.random() > 0.5 ? 1 : -1;
      // Occasionally bigger changes
      const magnitude = Math.random() > 0.85 ? Math.floor(Math.random() * 3) + 1 : 1;
      count = Math.max(8, Math.min(50, count + (change * magnitude)));

      // Animate the change
      viewersEl.style.transform = 'scale(1.1)';
      viewersEl.textContent = count;
      setTimeout(() => {
        viewersEl.style.transform = 'scale(1)';
      }, 200);
    }, Math.floor(Math.random() * 20000) + 20000);
  }

  /* =====================================================
     2. STICKY MOBILE BAR
     ===================================================== */
  function initStickyBar() {
    const stickyBar = document.querySelector('.mobile-sticky-bar');
    const ctaBlock = document.querySelector('.cta-block-new');

    if (!stickyBar || !ctaBlock) return;

    // Add body class for padding
    document.body.classList.add('has-sticky-bar');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      });
    }, {
      threshold: 0,
      rootMargin: '-100px 0px 0px 0px'
    });

    observer.observe(ctaBlock);

    // Show bar on scroll up, hide on scroll down (optional enhancement)
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > lastScroll && currentScroll > 300) {
        stickyBar.style.transform = 'translateY(100%)';
      } else {
        stickyBar.style.transform = 'translateY(0)';
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* =====================================================
     3. QUANTITY CONTROLS
     ===================================================== */
  function initQuantityControls() {
    const minusBtn = document.querySelector('.sticky-qty-btn.minus, .sticky-qty-minus');
    const plusBtn = document.querySelector('.sticky-qty-btn.plus, .sticky-qty-plus');
    const qtyDisplay = document.querySelector('.sticky-qty');
    const mainQtyInput = document.querySelector('.quantity-selector__input, [name="quantity"]');
    const priceDisplay = document.querySelector('.sticky-price .price-value');

    if (!minusBtn || !plusBtn || !qtyDisplay) return;

    // Get base price from data attribute or parse from display
    let basePrice = parseFloat(priceDisplay?.dataset?.basePrice ||
                              priceDisplay?.textContent?.replace(/[^\d,]/g, '').replace(',', '.') || 0);

    function updateQuantity(delta) {
      let qty = parseInt(qtyDisplay.textContent) || 1;
      qty = Math.max(1, qty + delta);

      // Animate
      qtyDisplay.style.transform = 'scale(1.2)';
      qtyDisplay.textContent = qty;
      setTimeout(() => {
        qtyDisplay.style.transform = 'scale(1)';
      }, 150);

      // Sync with main quantity input
      if (mainQtyInput) {
        mainQtyInput.value = qty;
        mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update sticky price
      if (priceDisplay && basePrice) {
        const total = basePrice * qty;
        priceDisplay.textContent = 'R$ ' + total.toFixed(2).replace('.', ',');
      }
    }

    minusBtn.addEventListener('click', () => updateQuantity(-1));
    plusBtn.addEventListener('click', () => updateQuantity(1));
  }

  /* =====================================================
     4. IMAGE GALLERY
     ===================================================== */
  function initGallery() {
    const mainImage = document.querySelector('.gallery-main img');
    const thumbs = document.querySelectorAll('.gallery-thumb');

    if (!mainImage || thumbs.length === 0) return;

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        // Remove active from all
        thumbs.forEach(t => t.classList.remove('active'));
        // Add active to clicked
        thumb.classList.add('active');

        // Get new image src
        const newSrc = thumb.querySelector('img')?.src ||
                      thumb.dataset.src ||
                      thumb.getAttribute('data-image');

        if (newSrc) {
          // Fade transition
          mainImage.style.opacity = '0';
          setTimeout(() => {
            mainImage.src = newSrc;
            mainImage.style.opacity = '1';
          }, 200);
        }
      });
    });

    // Set first as active
    if (thumbs[0]) {
      thumbs[0].classList.add('active');
    }

    // Touch swipe on mobile
    let touchStartX = 0;
    let touchEndX = 0;
    let currentIndex = 0;

    const galleryMain = document.querySelector('.gallery-main');
    if (galleryMain) {
      galleryMain.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      galleryMain.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });
    }

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0 && currentIndex < thumbs.length - 1) {
          // Swipe left - next
          currentIndex++;
          thumbs[currentIndex].click();
        } else if (diff < 0 && currentIndex > 0) {
          // Swipe right - prev
          currentIndex--;
          thumbs[currentIndex].click();
        }
      }
    }
  }

  /* =====================================================
     5. LIGHTBOX
     ===================================================== */
  function initLightbox() {
    const mainImage = document.querySelector('.gallery-main');
    const thumbs = document.querySelectorAll('.gallery-thumb');

    if (!mainImage) return;

    // Create lightbox elements if not exists
    let lightbox = document.querySelector('.lightbox-overlay');
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'lightbox-overlay';
      lightbox.innerHTML = `
        <button class="lightbox-close"><i class="fa fa-times"></i></button>
        <button class="lightbox-nav lightbox-prev"><i class="fa fa-chevron-left"></i></button>
        <img class="lightbox-image" src="" alt="">
        <button class="lightbox-nav lightbox-next"><i class="fa fa-chevron-right"></i></button>
      `;
      document.body.appendChild(lightbox);
    }

    const lightboxImage = lightbox.querySelector('.lightbox-image');
    const closeBtn = lightbox.querySelector('.lightbox-close');
    const prevBtn = lightbox.querySelector('.lightbox-prev');
    const nextBtn = lightbox.querySelector('.lightbox-next');

    // Collect all images
    const images = [];
    const mainImg = mainImage.querySelector('img');
    if (mainImg) images.push(mainImg.src);
    thumbs.forEach(thumb => {
      const img = thumb.querySelector('img');
      if (img && !images.includes(img.src)) {
        images.push(img.src);
      }
    });

    let currentLightboxIndex = 0;

    function openLightbox(src) {
      currentLightboxIndex = images.indexOf(src);
      if (currentLightboxIndex === -1) currentLightboxIndex = 0;

      lightboxImage.src = src || images[0];
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
    }

    function navigateLightbox(direction) {
      currentLightboxIndex += direction;
      if (currentLightboxIndex >= images.length) currentLightboxIndex = 0;
      if (currentLightboxIndex < 0) currentLightboxIndex = images.length - 1;

      lightboxImage.style.opacity = '0';
      setTimeout(() => {
        lightboxImage.src = images[currentLightboxIndex];
        lightboxImage.style.opacity = '1';
      }, 150);
    }

    // Event listeners
    mainImage.addEventListener('click', () => {
      const img = mainImage.querySelector('img');
      if (img) openLightbox(img.src);
    });

    closeBtn?.addEventListener('click', closeLightbox);
    prevBtn?.addEventListener('click', () => navigateLightbox(-1));
    nextBtn?.addEventListener('click', () => navigateLightbox(1));

    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) closeLightbox();
    });

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('active')) return;

      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') navigateLightbox(-1);
      if (e.key === 'ArrowRight') navigateLightbox(1);
    });
  }

  /* =====================================================
     6. TABS
     ===================================================== */
  function initTabs() {
    const tabBtns = document.querySelectorAll('.tab-btn');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabBtns.length === 0) return;

    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const targetId = btn.dataset.tab;

        // Remove active from all
        tabBtns.forEach(b => b.classList.remove('active'));
        tabContents.forEach(c => c.classList.remove('active'));

        // Add active to clicked
        btn.classList.add('active');
        const targetContent = document.getElementById(targetId);
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });

    // Set first tab as active
    if (tabBtns[0] && tabContents[0]) {
      tabBtns[0].classList.add('active');
      tabContents[0].classList.add('active');
    }
  }

  /* =====================================================
     7. FAQ ACCORDION
     ===================================================== */
  function initFAQ() {
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach(item => {
      const question = item.querySelector('.faq-question');

      question?.addEventListener('click', () => {
        const isActive = item.classList.contains('active');

        // Close all others
        faqItems.forEach(i => i.classList.remove('active'));

        // Toggle current
        if (!isActive) {
          item.classList.add('active');
        }
      });
    });
  }

  /* =====================================================
     8. SMOOTH SCROLL
     ===================================================== */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;

        const target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          const headerHeight = document.querySelector('header')?.offsetHeight || 80;
          const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  /* =====================================================
     9. ADD TO CART SYNC
     ===================================================== */
  function initAddToCartSync() {
    const stickyBuyBtn = document.querySelector('.sticky-buy');
    const mainAddToCartBtn = document.querySelector('.product-form__add-button, [type="submit"][name="add"]');

    if (!stickyBuyBtn || !mainAddToCartBtn) return;

    stickyBuyBtn.addEventListener('click', () => {
      // Trigger click on main add to cart button
      mainAddToCartBtn.click();

      // Visual feedback
      stickyBuyBtn.textContent = 'ADICIONANDO...';
      stickyBuyBtn.disabled = true;

      setTimeout(() => {
        stickyBuyBtn.textContent = 'COMPRAR';
        stickyBuyBtn.disabled = false;
      }, 1500);
    });
  }

  /* =====================================================
     10. VARIANT SELECTOR ENHANCEMENT
     ===================================================== */
  function initVariantSelector() {
    const variantOptions = document.querySelectorAll('.variant-option');

    variantOptions.forEach(option => {
      option.addEventListener('click', () => {
        if (option.classList.contains('disabled')) return;

        // Find siblings in same group
        const group = option.closest('.variant-options');
        group?.querySelectorAll('.variant-option').forEach(opt => {
          opt.classList.remove('active');
        });

        option.classList.add('active');

        // Trigger native variant change if exists
        const variantValue = option.dataset.value;
        const nativeSelect = document.querySelector(`select[name="options[${option.dataset.option}]"]`);
        if (nativeSelect && variantValue) {
          nativeSelect.value = variantValue;
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  /* =====================================================
     11. SCROLL REVEAL ANIMATIONS
     ===================================================== */
  function initScrollReveal() {
    const revealElements = document.querySelectorAll('.trust-bar, .reviews-section, .faq-section');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });

    revealElements.forEach(el => observer.observe(el));
  }

  /* =====================================================
     12. PRICE FORMATTER
     ===================================================== */
  window.formatPrice = function(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  };

  /* =====================================================
     13. HELPER: Update Price Display
     ===================================================== */
  window.updatePriceDisplay = function(price, comparePrice) {
    const currentPriceEl = document.querySelector('.price-current .value');
    const originalPriceEl = document.querySelector('.price-original .value');
    const discountBadgeEl = document.querySelector('.discount-badge');
    const stickyPriceEl = document.querySelector('.sticky-price .price-value');

    if (currentPriceEl) {
      currentPriceEl.textContent = formatPrice(price);
    }

    if (stickyPriceEl) {
      stickyPriceEl.textContent = formatPrice(price);
      stickyPriceEl.dataset.basePrice = (price / 100).toFixed(2);
    }

    if (originalPriceEl && comparePrice && comparePrice > price) {
      originalPriceEl.textContent = formatPrice(comparePrice);
      originalPriceEl.parentElement.style.display = 'flex';

      if (discountBadgeEl) {
        const discount = Math.round((1 - price / comparePrice) * 100);
        discountBadgeEl.textContent = `-${discount}%`;
        discountBadgeEl.style.display = 'inline-block';
      }
    } else {
      if (originalPriceEl) originalPriceEl.parentElement.style.display = 'none';
      if (discountBadgeEl) discountBadgeEl.style.display = 'none';
    }
  };

})();
